import { css } from '@emotion/react';

export const styles = {
  container: css`
    display: flex;
    flex-wrap: wrap;
    flex-spacing: 10px;
    min-height: 100px;
    margin-bottom: 30px;
    padding: 10px;
    gap: 10px;
  `,
  thumbnail: css`
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    min-height: 120px;
    width: 120px;
  `,
  selected: css`
    border: 2px solid red;
  `,
  hidden: css`
    display: none;
  `,
  photosActions: css`
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: #4d4d4d;
  `,
  deletePhotoBtn: css`
    position: absolute;
    right: 5px;
    top: 5px;
    background-color: #000;
    color: #fff;
    width: 25px;
    min-width: 25px;
    height: 25px;
    min-height: 25px;
  `,
  deletePhotoBtnIcon: css`
    width: 20px;
    height: 20px;
  `,
  addPhotoBtn: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    min-height: 120px;
  `,
  addPhotoBtnIconContainer: css`
    color: '#dbdbdb';
  `,
  addPhotoBtnIcon: css`
    width: 40px;
    height: 40px;
  `,
  emptyState: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    margin-bottom: 10px;
    max-height: 200px;
    justify-content: center;
    background-color: #1f2128;
  `,
  inputget: css`
    font-size: 1px;
    position: absolute;
    z-index: -1;
  `,
  dialogText: css`
    font-weight: 500;
  `,
  photoWrapper: css`
    -webkit-user-select: none;
    border: none;
    padding: 0;
  `,
  thumbnailContainer: css`
    min-width: 0;
    width: 120px;
  `,

  description: css`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-height: 10px

    font-size: 14px;
    margin-bottom: 0px;
  `
};
